import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';

import InputItem from '../Forms/InputItem/InputItem';
import FormButton from '../Forms/FormButton/FormButton';
import Fader from '../Loaders/Fader';

import { setNotify } from '../../../datastore/actions/actionActions';
import { sendResponse } from '../../../http/feedbackAPI';
import useOutsideClick from '../../../hooks/useOutsideClick';

import './ReplyModal.scss';

const ReplyModal = ({ isOpen, setIsOpen, caseId, recipientEmail, handleGetFeedbackData }) => {
  const dispatch = useDispatch();

  const [reply, setReply] = useState('');
  const [saving, setSaving] = useState(false);
  const [containerHeight, setContainerHeight] = useState(0);

  const { userInfo } = useOutletContext();

  const config = useSelector((state) => state.config.config);

  const windowRef = useRef();

  useEffect(() => {
    const updateHeight = () => {
      if (windowRef.current) {
        setContainerHeight(windowRef.current.clientHeight);
      }
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  const handleCloseForm = () => {
    setIsOpen(false);
  };

  const handleSendReply = async () => {
    if (reply) {
      setSaving(true);

      const res = await sendResponse(config, userInfo.id, caseId, recipientEmail, reply);

      if (res.status === 201) {
        dispatch(
          setNotify({
            status: true,
            type: 'success',
            title: 'Success',
            message: res.data.message,
          }),
        );

        handleGetFeedbackData();
        handleCloseForm();
      } else {
        dispatch(
          setNotify({
            status: true,
            type: 'error',
            title: 'Error',
            message: res.data.message,
          }),
        );
      }
      setSaving(false);
    } else {
      dispatch(
        setNotify({
          status: true,
          type: 'error',
          title: 'Error',
          message: 'Fill in all required fields',
        }),
      );
    }
  };

  useOutsideClick(windowRef, null, isOpen, handleCloseForm);

  return ReactDOM.createPortal(
    <div className="login-wrap feedback">
      <div className={`login-view ${saving ? 'saving' : ''}`}>
        <div ref={windowRef} className="login-box response__box">
          {!saving ? (
            <>
              <div className="feedback__title">Send Response</div>
              <div className="response__subtitle">
                The message will be sent to <strong>{recipientEmail}</strong>
              </div>
            </>
          ) : (
            <>
              <div className="info__title">Sending Response</div>
              <div className="info__text">The process should take no longer than 30 seconds. Please Wait...</div>
            </>
          )}
          {!saving ? (
            <>
              <div className="response__wrapper" style={{ height: containerHeight - 152 }}>
                <PerfectScrollbar
                  options={{
                    wheelPropagation: false,
                    autoHide: false,
                  }}
                >
                  <div className="feedback__form">
                    <InputItem
                      label="Message *"
                      onChange={(e) => setReply(e.target.value)}
                      value={reply}
                      isText={true}
                    />
                  </div>
                </PerfectScrollbar>
              </div>
              <div className="submit">
                <FormButton
                  subLink={'Cancel'}
                  subLinkClick={handleCloseForm}
                  text={'Submit'}
                  onClick={handleSendReply}
                />
              </div>
            </>
          ) : (
            <Fader size={50} />
          )}
        </div>
      </div>
    </div>,
    document.getElementById('root'),
  );
};

export default ReplyModal;
